import { useEffect, useState, useContext } from "react";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import MDBox from "components/MDBox";

import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import AsyncSelect from "react-select/async";
import { Alert, Collapse, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { LanguageContext } from "App";
// API imports
import UsersApi from "../../../Classes/API/UsersApi";
import SessionsApi from "../../../Classes/API/Administration/SessionsApi";
import searchSessionsReq from "../../../Classes/Models/Requests/Administration/CreateSessionReq";
import searchUsersReq from "../../../Classes/Models/Requests/Users/SearchUser";
import UserTypes from "../../../Classes/Models/Requests/Users/UserTypes";
import Swal from "sweetalert2";
import CreateBatchAccountingSessionsReq from "../../../Classes/Models/Requests/Accounting/CreateBatchAccountingSessionsReq";
import AccountingSessionBatchItem from "../../../Classes/Models/Requests/Accounting/AccountingSessionBatchItem";
import NewClientEvalModal from "./NewClientEvalModal";
import { useTenant } from "../../../context/TenantContext";

const CreateBatchAccountingSessions = ({ setCreatedNewSession }) => {
  const { translations } = useContext(LanguageContext);
  const [openEvalModal, setOpenEvalModal] = useState(false);
  const { currentTenant } = useTenant();
  const [UnpaidExceptions, setUnpaidExceptions] = useState(false);
  const [UnpaidExceptionsCount, setUnpaidExceptionsCount] = useState(0);

  const [Patient, setPatient] = useState({});
  const [SelectedPatient, setSelectedPatient] = useState([]);
  const [UnpaidExceptionDates, setUnpaidExceptionDates] = useState([]);
  const [SessionItems, setSessionItems] = useState([
    {
      id: Date.now(),
      session: {},
      originalPrice: "",
      discount: 0,
      finalPrice: 0,
      therapistId: "",
      selectedSession: [],
    },
  ]);

  useEffect(() => {
    GetPatients().then((res) => {
      setSelectedPatient(res);
    });
  }, []);

  useEffect(() => {
    if (Patient && Object.keys(Patient).length > 0) {
      const updatedItems = SessionItems.map((item) => ({
        ...item,
        selectedSession: [],
      }));
      setSessionItems(updatedItems);

      updatedItems.forEach((item, index) => {
        GetSessions(true).then((res) => {
          setSessionItems((prev) =>
            prev.map((prevItem, prevIndex) =>
              prevIndex === index
                ? { ...prevItem, selectedSession: res }
                : prevItem,
            ),
          );
        });
      });
    }
  }, [Patient]);

  const GetSessions = async (inputValue = "") => {
    if (!Patient || Object.keys(Patient).length === 0) return [];

    const searchReq = new searchSessionsReq();

    if (Patient.getPatient?.contractId) {
      searchReq.ContractId = Patient.getPatient.contractId;
    } else {
      searchReq.ContractId = undefined;
      searchReq.IsContractSession = false;
    }
    searchReq.Name = inputValue;
    searchReq.SecretName = inputValue;

    const res = await SessionsApi.SearchSessions(searchReq);

    if (res.status == "Success") {
      let optionsArr = res.data.list.map((item) => ({
        value: item,
        label: item.name,
      }));
      if (inputValue) {
        optionsArr = optionsArr.filter((item) =>
          item.label.toLowerCase().includes(inputValue.toLowerCase()),
        );
      }
      return optionsArr;
    }
    return [];
  };

  const GetPatients = async (inputValue = "") => {
    const searchReq = new searchUsersReq();
    const UserTypes1 = new UserTypes();

    searchReq.name = inputValue;
    searchReq.userType = UserTypes1.Patient;
    const res = await UsersApi.SearchUsers(searchReq);

    if (res.status == "Success") {
      let optionsArr = res.data.list.map((item) => ({
        value: item,
        label: item.name,
      }));

      return optionsArr;
    }
    return [];
  };

  const GetOriginalPrice = (session, patient) => {
    if (!session || !patient) return "";
    let originalPrice = 0;
    if (patient.nationalityGroup == "Egyptian") {
      originalPrice = session.egyptianPrice;
    } else if (patient.nationalityGroup == "Arab") {
      originalPrice = session.arabPrice;
    } else if (patient.nationalityGroup == "Other") {
      originalPrice = session.otherPrice;
    } else {
      return "PRICE NOT FOUND";
    }
    return originalPrice;
  };
  const showUnpaidExceptionAlert = () => (
    <Collapse in={UnpaidExceptions}>
      <Alert
        severity="error"
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => setUnpaidExceptions(false)}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        sx={{ mb: 2 }}
      >
        This patient has {UnpaidExceptionsCount} unpaid appointment(s)
        (exception) on: {UnpaidExceptionDates.join(", ")}
      </Alert>
    </Collapse>
  );

  const checkUnpaidExceptions = (patient) => {
    const unpaidSessions = patient.getPatient.getAccountingSessions.filter(
      (session) => session.isException && !session.isPaidFor,
    );
    const dates = unpaidSessions.map((session) => {
      const date = new Date(session.timeStamp);
      return date.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });
    });
    setUnpaidExceptions(unpaidSessions.length > 0);
    setUnpaidExceptionsCount(unpaidSessions.length);
    setUnpaidExceptionDates(dates);
  };

  const addSessionItem = async () => {
    const newItem = {
      id: Date.now(),
      session: {},
      originalPrice: "",
      discount: 0,
      therapistId: "",
      selectedSession: [],
    };

    let sessions = [];
    if (Object.keys(Patient).length > 0) {
      sessions = await GetSessions(true);
    }

    newItem.selectedSession = sessions;
    setSessionItems((prev) => [...prev, newItem]);
  };

  const removeSessionItem = (itemId) => {
    if (SessionItems.length > 1) {
      setSessionItems(SessionItems.filter((item) => item.id !== itemId));
    }
  };

  const updateSessionItem = (itemId, field, value) => {
    setSessionItems((prev) =>
      prev.map((item) => {
        if (item.id === itemId) {
          const updatedItem = { ...item, [field]: value };

          if (field === "session" && Object.keys(Patient).length > 0) {
            const price = GetOriginalPrice(value, Patient);
            updatedItem.originalPrice = price;
            updatedItem.finalPrice = price;
          }

          if (
            field === "discount" &&
            item.isDiscountMode &&
            item.originalPrice
          ) {
            updatedItem.finalPrice = Math.floor(
              item.originalPrice - (item.originalPrice * value) / 100,
            );
          }

          if (
            field === "finalPrice" &&
            !item.isDiscountMode &&
            item.originalPrice
          ) {
            updatedItem.discount =
              ((item.originalPrice - value) / item.originalPrice) * 100;
          }

          return updatedItem;
        }
        return item;
      }),
    );
  };
  const onSubmit = async () => {
    if (Patient?.getPatient?.id === undefined) {
      Swal.fire({
        title: "Error",
        text: "Please select a patient",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    const invalidItems = SessionItems.filter((item) => !item.session?.id);

    if (invalidItems.length > 0) {
      Swal.fire({
        title: "Error",
        text: "Please select sessions and ensure all prices are calculated",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    const req = new CreateBatchAccountingSessionsReq();
    req.PatientId = Patient?.getPatient?.id;
    req.Sessions = SessionItems.map((item) => {
      const sessionItem = new AccountingSessionBatchItem();
      sessionItem.SessionId = item.session.id;
      sessionItem.OriginalPrice = Number.parseFloat(item.originalPrice) || 0;
      sessionItem.Discount = Number.parseFloat(item.discount) || 0;
      sessionItem.FinalPrice = Number.parseFloat(item.finalPrice) || 0;
      sessionItem.TherapistId = item.therapistId || null;
      return sessionItem;
    });

    try {
      const res = await SessionsApi.CreateBatchAccountingSessions(req);
      if (res.status == "Success") {
        Swal.fire({
          title: "Success",
          text: res.message,
          icon: "success",
        });

        setCreatedNewSession(true);
        setSessionItems([
          {
            id: Date.now(),
            session: {},
            originalPrice: "",
            discount: "",
            finalPrice: "",
            therapistId: "",
            selectedSession: [],
          },
        ]);
        setPatient(null);
        setSelectedPatient([]);
      } else {
        Swal.fire({
          title: "Error",
          text: res.message || "Something went wrong",
          icon: "error",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Failed to create accounting sessions",
        icon: "error",
      });
    }
  };

  return (
    <Card sx={{ mb: 3 }} id="CreateBatchAccountingSessions">
      <MDBox pt={2} px={2} display="flex" flexDirection="column">
        {showUnpaidExceptionAlert()}
      </MDBox>
      <Box
        sx={{
          pt: 2,
          px: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" fontWeight="medium">
          Create Batch Accounting Sessions
        </Typography>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            onClick={() => setOpenEvalModal(true)}
            variant="outlined"
            sx={{ color: "#3560AD" }}
            startIcon={<Icon>person_add</Icon>}
          >
            New Client Eval
          </Button>
          <Button
            onClick={() => onSubmit()}
            variant="contained"
            sx={{
              backgroundColor: "#3560AD",
              "&:hover": { backgroundColor: "#4682B4" },
              color: "#ffffffff",
              textTransform: "none",
              fontWeight: 600,
            }}
            startIcon={<Icon>add</Icon>}
          >
            Create {SessionItems.length} Session
            {SessionItems.length > 1 ? "s" : ""}
          </Button>
        </Box>
      </Box>

      <form id="CreateBatchAccountingSessionsForm">
        <Box sx={{ p: 3 }}>
          {/* Patient Selection */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="body2" fontWeight="medium" sx={{ mb: 1 }}>
              Select Patient
            </Typography>
            <AsyncSelect
              placeholder="Select Patient"
              isClearable={true}
              loadOptions={(inputValue) => GetPatients(inputValue)}
              defaultOptions={SelectedPatient}
              onChange={(e) => {
                if (!e) {
                  setPatient(null);
                  setSessionItems([
                    {
                      id: Date.now(),
                      session: {},
                      originalPrice: "",
                      discount: 0,
                      finalPrice: 0,
                      therapistId: "",
                      selectedSession: [],
                    },
                  ]);
                  setUnpaidExceptions(false);
                  return;
                }
                const patient = e?.value || {};
                setPatient(patient);
                if (Object.keys(patient).length > 0) {
                  checkUnpaidExceptions(patient);
                }
              }}
              value={
                Patient ? { value: Patient, label: Patient.name || "" } : null
              }
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: 40,
                  borderRadius: 8,
                  borderColor: "#e0e0e0",
                  "&:hover": {
                    borderColor: "#3560AD",
                  },
                  ...(translations.setlang === "ar"
                    ? { direction: "rtl" }
                    : {}),
                }),
                placeholder: (base) => ({
                  ...base,
                  color: "#666",
                  ...(translations.setlang === "ar"
                    ? { textAlign: "right" }
                    : {}),
                }),
                singleValue: (base) => ({
                  ...base,
                  ...(translations.setlang === "ar"
                    ? { textAlign: "right" }
                    : {}),
                }),
                menu: (provided) => ({
                  ...provided,
                  zIndex: 9999,
                  borderRadius: 8,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                }),
              }}
            />
          </Box>

          <Divider sx={{ my: 2 }} />

          {/* Session Items */}
          <Box sx={{ mt: 3 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography variant="body2" fontWeight="medium">
                Accounting Sessions ({SessionItems.length})
              </Typography>
              <Button
                onClick={addSessionItem}
                variant="outlined"
                size="small"
                sx={{
                  textTransform: "none",
                  borderRadius: 2,
                  fontWeight: 500,
                  color: "#3560AD",
                }}
                startIcon={<Icon>add</Icon>}
              >
                Add Session
              </Button>
            </Box>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                gap: 2,
                "@media (max-width: 1200px)": {
                  gridTemplateColumns: "repeat(3, 1fr)",
                },
                "@media (max-width: 900px)": {
                  gridTemplateColumns: "repeat(2, 1fr)",
                },
                "@media (max-width: 600px)": {
                  gridTemplateColumns: "1fr",
                },
              }}
            >
              {SessionItems.map((item, index) => (
                <Card
                  key={item.id}
                  sx={{ p: 2, border: "1px solid #f0f0f0", borderRadius: 2 }}
                >
                  {/* Session Item Header */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <Typography
                      variant="body2"
                      fontWeight="medium"
                      color="primary"
                    >
                      Session #{index + 1}
                    </Typography>
                    {SessionItems.length > 1 && (
                      <IconButton
                        onClick={() => removeSessionItem(item.id)}
                        size="small"
                        sx={{
                          color: "#f44336",
                          "&:hover": {
                            backgroundColor: "rgba(244, 67, 54, 0.1)",
                          },
                        }}
                      >
                        <Icon>delete</Icon>
                      </IconButton>
                    )}
                  </Box>

                  {/* Session Content Layout */}
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                  >
                    {/* Session Selection */}
                    <Box>
                      <Typography
                        variant="caption"
                        fontWeight="medium"
                        sx={{ mb: 1, display: "block" }}
                      >
                        Select Session
                      </Typography>
                      <AsyncSelect
                        placeholder="Select Session"
                        loadOptions={(inputValue) => GetSessions(inputValue)}
                        onChange={(e) =>
                          updateSessionItem(item.id, "session", e?.value || {})
                        }
                        defaultOptions={item.selectedSession}
                        menuPortalTarget={document.body}
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: 40,
                            borderRadius: 8,
                            borderColor: "#e0e0e0",
                            "&:hover": { borderColor: "#3560AD" },
                            ...(translations.setlang === "ar"
                              ? { direction: "rtl" }
                              : {}),
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                          placeholder: (base) => ({
                            ...base,
                            color: "#666",
                            ...(translations.setlang === "ar"
                              ? { textAlign: "right" }
                              : {}),
                          }),
                          singleValue: (base) => ({
                            ...base,
                            ...(translations.setlang === "ar"
                              ? { textAlign: "right" }
                              : {}),
                          }),
                          menu: (provided) => ({
                            ...provided,
                            borderRadius: 8,
                            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                          }),
                        }}
                      />
                    </Box>

                    {/* Pricing Information */}
                    {Object.keys(item.session).length > 0 &&
                      Object.keys(Patient).length > 0 && (
                        <Box>
                          <Typography
                            variant="caption"
                            fontWeight="medium"
                            sx={{ mb: 1, display: "block" }}
                          >
                            Pricing Details
                          </Typography>
                          <Box
                            sx={{
                              p: 2,
                              backgroundColor: "#f8f9fa",
                              borderRadius: 2,
                              border: "1px solid #e9ecef",
                              mb: 2,
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{ mb: 1, color: "#495057" }}
                            >
                              <strong>Nationality:</strong>{" "}
                              {Patient.nationalityGroup}
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ mb: 1, color: "#495057" }}
                            >
                              <strong>Original Price:</strong>{" "}
                              {item.originalPrice} EGP
                            </Typography>
                          </Box>

                          <TextField
                            type="number"
                            label={
                              item.isDiscountMode
                                ? "Discount %"
                                : "Final Price (EGP)"
                            }
                            value={
                              item.isDiscountMode
                                ? item.discount
                                : item.finalPrice
                            }
                            onChange={(e) =>
                              updateSessionItem(
                                item.id,
                                item.isDiscountMode ? "discount" : "finalPrice",
                                e.target.value,
                              )
                            }
                            size="small"
                            fullWidth
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                borderRadius: 2,
                              },
                            }}
                          />

                          <Typography
                            variant="caption"
                            color="text"
                            sx={{ mt: 1, ml: 1 }}
                          >
                            {item.isDiscountMode
                              ? `Final Price: ${Number(item.finalPrice).toFixed(
                                  1,
                                )} EGP`
                              : `Discount: ${Number(item.discount).toFixed(
                                  1,
                                )}%`}
                          </Typography>
                        </Box>
                      )}
                    {/* Toggle Button */}
                    <Button
                      variant="outlined"
                      color="info"
                      onClick={() =>
                        updateSessionItem(
                          item.id,
                          "isDiscountMode",
                          !item.isDiscountMode,
                        )
                      }
                      sx={{
                        px: 3,
                        py: 1,

                        fontSize: "0.8rem",
                        borderRadius: "10px",
                        backgroundColor: "#3560AD",
                        color: "#ffff",
                        "&:hover": { backgroundColor: "#3560aD" },
                      }}
                    >
                      {item.isDiscountMode
                        ? "Switch to Final Price"
                        : "Switch to Discount %"}
                    </Button>
                  </Box>
                </Card>
              ))}
              <NewClientEvalModal
                open={openEvalModal}
                onClose={() => setOpenEvalModal(false)}
                onSuccess={() => setCreatedNewSession(true)}
                tenantId={currentTenant?.id}
              />
            </Box>
          </Box>
        </Box>
      </form>
    </Card>
  );
};

export default CreateBatchAccountingSessions;
